<template>

  <!--<v-app light>-->
  <!--<Toolbar :drawer="app.drawer"></Toolbar>-->
  <!--<Sidebar :drawer="app.drawer"></Sidebar>-->
  <!--</v-app>-->

  <v-app light>

    <main-navigation-drawer
      ref="drawerMain"
      :drawer="drawer"
      @drawer_change="drawer_change"
    >
    </main-navigation-drawer>

    <main-bar
      ref="barMain"
      :drawer="drawer"
      @drawer_change="drawer_change">
      <template slot="header">
        <slot name="header"/>
      </template>

      <template slot="toolbar-items">

        <v-spacer/>

        <slot name="toolbar-items" :project="project"/>

        <v-spacer/>

        <v-toolbar-items>

          <!--          <v-select label="Project" :items="project_list"></v-select>-->

          <v-tooltip bottom open-delay="100ms">
            <template v-slot:activator="{ on }">
              <v-btn icon @click="newMessage()" v-on="on">
                <v-icon>add</v-icon>
              </v-btn>

            </template>
            <span>{{message_count}}</span>
          </v-tooltip>


        </v-toolbar-items>


        <v-menu bottom left offset-y z-index="200"
                :close-on-content-click="false"
                v-model="shown_user_card">
          <!-- z-index=200 to overflow handsontable columns' headers z-index=160 -->

          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>

          </template>
          <user-card @close="shown_user_card = false">
          </user-card>
        </v-menu>

      </template>

    </main-bar>

    <v-main style="padding-top: 0;">
      <!-- тег v-main важен, чтобы панель навигации (слева)
           не накрывала содержимое страницы -->
      <div :style="contentStyle">
        <slot name="content"></slot>
      </div>
    </v-main>

    <!-- messages -->
    <v-snackbar
      ref="snackbarMessages"
      :value="message_visibility"
      bottom left :timeout="-1"
    >
      <v-container>
        <v-row
          v-for="msg in message_list" :key="msg.id"
        >
          <v-col cols="12">

            <!--            <v-tooltip top open-delay="100ms">-->
            <!--              <template v-slot:activator="{ on }">-->
            <v-alert
              :type="msg.type" :dismissible="msg.type==='error'"
              @input="alertMessage_input(msg)">
              <div v-html="msg.html"
                   style="max-height: 350px; overflow: auto;">
              </div>
            </v-alert>
            <!--                <span>hallo</span>-->
            <!--              </template>-->
            <!--            </v-tooltip>-->

          </v-col>
        </v-row>
      </v-container>
    </v-snackbar>

    <!-- progress -->
    <v-dialog v-model="progress_progressing"
              :hide-overlay="!progress_progressing"
              persistent close-delay="200ms"
              max-width="450px">
      <v-card style="text-align: center;">
        <v-card-title style="word-break: break-word;">
          {{progress_message}}
        </v-card-title>

        <v-card-text>
          <div v-if="progress_value === -1">
            <v-progress-circular indeterminate>
            </v-progress-circular>
          </div>

          <div v-else>
            <v-progress-circular :value="progress_value">
            </v-progress-circular>
            <span>Progressed {{progress_value}}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-app>

</template>

<script>

	import {mdiAccount} from '@mdi/js'

	import format from 'string-format'
	import {
		VApp, VMain
	} from 'vuetify'
	import UserCardComponent from '../../components/auth/UserCardComponent'

	import {mapGetters} from 'vuex'

	// import MainBarComponent
	// 	from '../../components/app/MainBarComponent'
	// import MainNavigationDrawerComponent
	// 	from '../../components/app/MainNavigationDrawerComponent'

	// import {
	// 	MainBarComponent,
	// 	MainNavigationDrawerComponent
	// } from '../../components/app'


	import {mdiBottleTonicPlus, mdiHospitalBoxOutline} from '@mdi/js'

	export default {
		name: "default-view",
		components: {
			VApp, VMain,
			// MainNavigationDrawerComponent,
			// MainBarComponent,
			// VList, VListItem, VListItemTitle, VListItemContent, VListItemAction,
			// VProgressCircular, VApp, VContent, VSpacer,
			// VToolbar, VToolbarItems, VToolbarTitle, VLayout,
			// VAppBarNavIcon, VIcon,
			UserCardComponent,
		},

		data: function () {
			return {
				drawer: true,
				clipped: false,
				miniVariant: false,

				windowHeight: 0,
				windowWidth: 0,

				shown_user_card: false,

				project: null,
			}
		},

		computed: {
			...mapGetters({
				project_items: 'lists/project_list',

				// отображение ошибок и сообщений
				message_list: 'message/list',
				message_visibility: 'message/visibility',
				message_count: 'message/count',

				// отображение прогресса
				progress_progressing: 'progress/progressing',
				progress_message: 'progress/message',
				progress_value: 'progress/value',
			}),

			contentStyle: function () {
				const drawerWidth = this.drawer && this.$refs.drawerMain
					? this.$refs.drawerMain.$el.clientWidth : 0

				return {
					width: (this.windowWidth - drawerWidth) + 'px',
					height: (this.windowHeight - 56 - 5) + 'px'
				}
			},
		},

		// -- Hooks --
		created: function () {
			console.log('DefaultView.created()')
		},

		mounted: function () {
			this.$nextTick(function () {
				window.addEventListener('resize', this.window_resize)
				this.window_resize()
			})
		},

		destroyed: function () {
			window.removeEventListener('resize', this.window_resize)
		},

		methods: {
			newMessage: function () {
				this.$store.dispatch(
					'message/add',
					{
						html: 'Message text',
						type: 'error'
					})
			},

			alert: function (msg) {
				alert(msg)
			},

			// -- Handle controls' events --

			window_resize: function () {
				this.windowHeight = window.innerHeight
				this.windowWidth = window.innerWidth
			},

			drawer_change: function (value) {
				// console.debug(format("DefaultView.drawer_change({0})", value))

				this.drawer = value
			},

			// -- messages (alerts) --

			alertMessage_input: function (msg) {
				this.$store.dispatch('message/remove', msg)
				// this.messages.splice(this.messages.indexOf(msg), 1)
			},
		},
	}
</script>

<style>

  .v-snack__content {
    width: 100%;
  }

  .v-snack__content .v-alert__content {
    overflow: auto;
  }
</style>